import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    Chart,
    ArgumentAxis,
    ValueAxis,
    LineSeries,
    Title,
    Tooltip
} from '@devexpress/dx-react-chart-material-ui';
import { EventTracker, Palette } from '@devexpress/dx-react-chart';

import { colors } from './../../utils/global';
import { startOfToday, getYear } from 'date-fns';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    paperMain: {
        padding: '10px',
        textAlign: 'center',
        minHeight: "450px",
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    lineChart: {
        maxHeight: '270px'
    }
});


const format = () => tick => tick;

const YearAxisLabel = props => {
    const { text } = props;
    const year = getYear(startOfToday());

    var newText = '';
    
    if(text === "Attivate Anno3") newText = year;
    else if (text === "Attivate Anno2")  newText = year - 1;
    else if (text === "Attivate Anno1") newText = year - 2;

    return (
        <ArgumentAxis.Label
            {...props}
            text={newText}
            textAnchor="middle"
            dominantBaseline="middle"
        />
    );
};

const titleStyles = {
    title: {
        whiteSpace: 'pre',
    },
};
const TitleText = withStyles(titleStyles)(({ classes, ...props }) => (
    <Title.Text {...props} className={classes.title} />
));

class LineChart extends Component {

    render() {
        const { classes, chartData } = this.props;

        return (
            <Chart
                className={classes.lineChart}
                data={chartData}
            >
                <Palette scheme={colors} />
                <ArgumentAxis tickFormat={format} labelComponent={YearAxisLabel} />
                <ValueAxis
                    max={8}
                />

                <LineSeries
                    valueField="val"
                    argumentField="type"
                />
                <Title
                    text="Attivate per anno"
                    textComponent={TitleText}
                />

                <EventTracker />
                <Tooltip />
            </Chart>
        );

    }
}

LineChart.propTypes = {
    chartData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default withStyles(styles)(LineChart);